__turbopack_context__.v({
  "action": "zeroState-module-scss-module__KfGLoW__action",
  "content": "zeroState-module-scss-module__KfGLoW__content",
  "icon": "zeroState-module-scss-module__KfGLoW__icon",
  "subcontent": "zeroState-module-scss-module__KfGLoW__subcontent",
  "text": "zeroState-module-scss-module__KfGLoW__text",
  "title": "zeroState-module-scss-module__KfGLoW__title",
  "zeroState": "zeroState-module-scss-module__KfGLoW__zeroState",
});
